function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Form from "../../../components/Form/Form";
import { Text } from "../../../components/Form/Text";
import HtmlText from "../../../components/HtmlText";
import { post } from "../../../utils";
import { Drawer as AntDrawer, Button, Input, Table, message } from 'antd';
import { useEffect, useRef } from 'react';
import styles from "./index.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PriceDrawer = function PriceDrawer(props) {
  var data = props.data,
    onClose = props.onClose,
    visible = props.visible;
  var cols = [{
    title: '操作人',
    dataIndex: 'operatorName'
  }, {
    title: '操作时间',
    dataIndex: 'operateTime'
  }, {
    title: '操作内容',
    dataIndex: 'content',
    render: function render(v) {
      return /*#__PURE__*/_jsx(HtmlText, {
        children: v
      });
    }
  }];
  return /*#__PURE__*/_jsx(AntDrawer, {
    open: visible,
    closable: true,
    onClose: onClose,
    title: "\u53D8\u4EF7\u8BB0\u5F55",
    width: 600,
    destroyOnClose: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.label,
        children: ["\u5546\u54C1\u7F16\u7801\uFF1A", data.skuCode]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.label,
        children: ["\u5546\u54C1\u540D\u79F0\uFF1A", data.skuName]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: "\u53D8\u4EF7\u8BB0\u5F55"
      }), /*#__PURE__*/_jsx(Table, {
        pagination: false,
        rowKey: function rowKey(record, index) {
          return index;
        },
        scroll: {
          x: 'max-content'
        },
        columns: cols,
        dataSource: data.priceChangeLogs
      })]
    })
  });
};
export var CodesDrawer = function CodesDrawer(props) {
  var data = props.data,
    _onClose = props.onClose,
    visible = props.visible,
    _props$numberKey = props.numberKey,
    numberKey = _props$numberKey === void 0 ? 'qty' : _props$numberKey,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'edit' : _props$mode;
  var _ref = data || {},
    _ref$snCodes = _ref.snCodes,
    snCodes = _ref$snCodes === void 0 ? [] : _ref$snCodes;
  var qty = isNaN(Number(data[numberKey])) ? 0 : Math.ceil(Number(data[numberKey]));
  var codes = snCodes;
  if (snCodes && snCodes.length !== qty && qty) {
    codes = new Array(qty).map(function (e, index) {
      return snCodes[index];
    });
  }
  var ref = useRef(null);
  useEffect(function () {
    var _ref$current;
    var codes = snCodes;
    if (snCodes && snCodes.length !== qty && qty) {
      codes = new Array(qty).fill(undefined).map(function (e, index) {
        return snCodes[index];
      });
    }
    (_ref$current = ref.current) === null || _ref$current === void 0 || (_ref$current = _ref$current.form) === null || _ref$current === void 0 || _ref$current.setFieldsValue({
      snCodes: codes
    });
  }, [snCodes, qty, data.skuCode, visible]);
  var cols = [{
    title: '商品编码',
    dataIndex: 'skuCode'
  }, {
    title: '商品名称',
    dataIndex: 'skuName'
  }, {
    title: '规格',
    dataIndex: 'spec'
  }, {
    title: '数量',
    dataIndex: numberKey
  }, {
    title: '单位',
    dataIndex: 'unit'
  }];
  return /*#__PURE__*/_jsx(AntDrawer, {
    open: visible,
    closable: true,
    onClose: function onClose() {
      return _onClose();
    },
    title: "\u586B\u5199\u5E8F\u5217\u53F7",
    width: 600,
    destroyOnClose: true,
    footer: /*#__PURE__*/_jsxs("div", {
      className: styles.filterFooter,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          return _onClose();
        },
        children: "\u53D6\u6D88"
      }), /*#__PURE__*/_jsx(Button, {
        type: "primary",
        onClick: function onClick() {
          var _ref$current2;
          (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.form.validateFields().then(function (values) {
            post({
              url: "/erp/scm/purchase/saveSns",
              data: _objectSpread(_objectSpread({}, values), {}, {
                uniqKey: data.uniqKey
              })
            }).then(function (result) {
              var code = result.code,
                d = result.data;
              if (code === 0) {
                message.success('保存成功！');
                _onClose(data.uniqKey, values.snCodes);
              }
            }).catch(function () {});
          }).catch(function () {});
        },
        children: "\u786E\u5B9A"
      })]
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(Table, {
        pagination: false,
        rowKey: function rowKey(record, index) {
          return index;
        },
        scroll: {
          x: 'max-content'
        },
        columns: cols,
        dataSource: [data]
      }), /*#__PURE__*/_jsx(Form, {
        mode: mode,
        ref: ref,
        className: mode === 'edit' ? styles.snCodes : styles.snViewCodes,
        children: /*#__PURE__*/_jsx(Form.List, {
          name: "snCodes",
          children: function children(fields) {
            return fields.map(function (field, index) {
              return /*#__PURE__*/_jsxs(Form.Field, {
                name: [field.name],
                label: "\u5546\u54C1\u5E8F\u5217\u53F7".concat(index + 1)
                // required
                // rules={[{ required: true, message: '请填写序列号' }]}
                ,
                children: [/*#__PURE__*/_jsx(Input, {
                  placeholder: "\u8BF7\u586B\u5199\u5E8F\u5217\u53F7"
                }), /*#__PURE__*/_jsx(Text, {})]
              }, index);
            });
          }
        })
      })]
    })
  });
};
export default PriceDrawer;